<template>
    <div>
        <div class="pc">
            <toptab :topback="true"></toptab>
            <div class="digital">
                <div class="createbutton">
                    <p @click="createflie()">立即定制</p>
                </div>
                <div class="microvideoboxleft">
                    <asidebar></asidebar>
                </div>
                <div class="microvideoboxright">
                    <el-scrollbar>
                        <div class="digitalbox">
                            <div>
                                <div class="titlebox">
                                    <div>
                                        <p>01.</p>
                                        <p>
                                            <span>选择一段视频</span>
                                            <span>请上传15-30秒以内正面清晰无噪音说话视频</span>
                                        </p>
                                    </div>
                                </div>
                               <div  class="tabbox2">
                                   <el-upload
									:before-upload="handleBeforeUpload"
                                       class="upload-demo"
                                       :limit="1"
                                       drag
                                       action=""
                                       accept="video/mp4,video/quicktime"
                                       :http-request="uploadVoice"
                                       :show-file-list="true"
                                       :file-list="voiceList">
                                       <div class="uploadbutton">
                                           <el-button type="primary"><i class="el-icon-upload2"></i>上传视频</el-button>
                                           <p>或拖拽视频到此区域</p>
                                       </div>
                                   </el-upload>
                               </div>
                            </div>
                            <div>
                                <div class="titlebox">
                                    <div>
                                        <p>02.</p>
                                        <p>
                                            <span>输入定制形象名称</span>
                                            <span>您可以输入定制形象名称</span>
                                        </p>
                                    </div>
                                    <!-- <div>
                                        <i class="el-icon-s-opportunity"></i>
                                        <span>没有灵感？插入范文</span>
                                    </div> -->
                                </div>
                                <div v-show="tabindex" class="tabbox1">
                                    <el-input
                                        type="input"
                                        placeholder="形象名称"
                                        resize="none"
                                        v-model="voiceForm.title"
                                        style="height: 60px;">
                                    </el-input>
                                    <div class="ali">
                                        <el-scrollbar>
                                            <ul class="usebox">
                                                <!-- <li @touchstart="itemStart" @touchend="itemEnd" v-for="(item,index) in cloneList" :key="index"> -->
                                                <li v-on:mousedown="itemStart(index)" v-on:mouseup="itemEnd(index)" v-for="(item,index) in cloneList" :key="index">
                                                    <div v-if="item.show_type == 1">{{item.title}}</div><i @click="deleteCustomizedItem(item)" v-if="item.show_type == 1" style="margin-left: 20px;" class="el-icon-close"></i>
													<el-input v-if="item.show_type == 2" v-model="item.title"></el-input><i @click="updateCustomizedItem(item)" v-if="item.show_type == 2" style="margin-left: 20px;" class="el-icon-check"></i>
												</li>
                                            </ul>
                                        </el-scrollbar>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <div class="mobile">
            <customizedm></customizedm>
        </div>
        <videoplay v-if="videoplaystatus" @colsevideo="colsevideo" :videoid="videoid"></videoplay>
    </div>
</template>

<script>
import videoplay from '@/components/videoplay'
import voiceplay from "@/components/voiceplay";
import toptab from "@/components/toptab"
import asidebar from "@/components/asidebar"
import customizedm from "@/components/customizedm"
import {uploadUploadVideoV2,voiceGetModelList,voiceGenerate,uploadUploadVoice} from "@/api/video"
import {getCustomizedList,customized,updateCustomized,deleteCustomized} from "@/api/customized"
export default {
    components: {
        toptab,
        asidebar,
        customizedm,
        videoplay,
        voiceplay
    },
    data(){
        return{
            dialogVisible:false,
            voiceList:[],
            voiceplaystatus:false,
            videoplaystatus: false,
            activeIndex:'1',
            textarea:"",
            tabindex:true,
            watermark:false,
            cartoon:false,
            attitude:0,
            listindex:0,
            list:[
   
            ],
            alitypeindex:2,
            alitype:[],
            cloneList:[],
			loop:null,
            voiceForm:{
                title:"",
                voice_url:"",
            },
            videoid:1,
        }
    },
    mounted(){
        this.getList()
    },
    methods:{
		itemStart(index) {
			if(this.cloneList[index].show_type == 2) {
				return;
			}
			clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
	        this.loop = setTimeout(() => {
	          	this.cloneList[index].show_type  = 2;
	        }, 1000);
		},
		itemEnd(index) {
			clearTimeout(this.loop); //清空定时器，防止重复注册定时器
		},
        createflie(){
			if(this.voiceList.length <= 0){
				this.$message.error('请上传视频');
				return false
			}
			this.voiceForm.video_url = this.voiceList[0].url;
			if(this.voiceForm.title==""){
				this.$message.error('形象名称不能为空');
				return false
			}
			const loading1 = this.$loading({
				lock: true,
				text: '视频定制....',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			customized(this.voiceForm).then(res=>{
				loading1.close()
				if(res.code == 0) {
					this.$message.success('定制成功');
					this.getList();
					this.voiceForm.title = "";
					this.voiceList = [];
				}else {
					this.$message.error(res.message)
				}
			})
        },
        colsevideo(){
            this.videoplaystatus=false
            this.voiceplaystatus = false
        },
        getList(){
            getCustomizedList({}).then(res=>{
			   this.cloneList = res.data;
            })
        },
		updateCustomizedItem(item) {
			const loading1 = this.$loading({
				lock: true,
				text: '修改中....',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			updateCustomized({id:item.id, title:item.title}).then(res=>{
				loading1.close()
				if(res.code == 0) {
					this.$message.success(res.message)
					this.getList();
				}else {
					this.$message.error(res.message)
				}
			})
		},
		deleteCustomizedItem(item) {
			this.$confirm('此操作将永久删除定制形象, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).then(() => {
			          const loading1 = this.$loading({
			          	lock: true,
			          	text: '删除中....',
			          	spinner: 'el-icon-loading',
			          	background: 'rgba(0, 0, 0, 0.7)'
			          });
			          deleteCustomized({id:item.id}).then(res=>{
			          	loading1.close()
			          	if(res.code == 0) {
			          		this.$message.success(res.message)
			          		this.getList();
			          	}else {
			          		this.$message.error(res.message)
			          	}
			          })
			        }).catch(() => {
			        });
			
		},
		handleBeforeUpload(file) {
		  //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
		  const is100M = file.size / 1024 / 1024 < 100;
		   //限制文件上传大小
		  if (!is100M) {
			this.$message.error("上传视频大小不能超过 100MB!");
			return false
		  }
		  return true
		},
        uploadVoice(e){
             const loading2 = this.$loading({
                lock: true, 
                text: '文件上传中....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const formData = new FormData()
            formData.append('file', e.file)
            uploadUploadVideoV2(formData).then(res=>{
                loading2.close();
				if(res.code == 0) {
					this.voiceList = [{url:res.data.fullurl,name:e.file.name, uid:e.file.uid}]
				}else {
					this.$message.error(res.message)
				}
                
            })
        },
    }
}
</script>

<style lang="less">
    .digital{
        display: flex;
        .createbutton{
            position: absolute;
            top: 12px;
            right: 80px;
            display: flex;
            p:nth-child(1){
                background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
                height: 36px;
                padding: 0 20px;
                border: 0;
                border-radius: 6px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-size: 14px;
            }
            p:nth-child(2){
                height: 36px;
                padding: 0 20px;
                border: 0;
                border-radius: 6px;
                background-color:rgb(244, 245, 247);
                color: #333;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 20px;
                cursor: pointer;
                font-size: 14px;
            }
        }
        .microvideoboxright{
            background-color: #f4f5f7;
            padding: 30px 20px 0;
            flex: 1 0 10%;
            // width:calc(100vw - 340px);
            >.el-scrollbar{
                height: calc(100vh - 90px);
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }

            .digitalbox{
                display: flex;
                gap: 20px;
                .titlebox{
                    display: flex;
                    justify-content: space-between;
                    div{
                        display: flex;
                        align-items: center;
                        p:nth-child(1){
                            color: #678bfe;
                            font-size: 20px;
                            font-weight: 700;
                            margin-right: 8px;
                        }
                        p:nth-child(2){
                            span{
                                display: block;
                            }
                            span:nth-child(1){
                                font-size: 20px;
                                font-weight: 700;
                                margin-bottom: 4px;
                                margin-bottom: 4px;
                            }
                            span:nth-child(2){
                                color: #999;
                                font-size: 14px;
                            }
                        }
                        i{
                            color: #E6A23C;
                        }
                        span{
                            font-size: 12px;
                            cursor: pointer;
                        }
                    }
                }
                > div{
                    padding: 20px;
                    background-color: #fff;
                    border-radius: 12px;
                    position: relative;
                    overflow: hidden;
                }
                > div:nth-child(1){
                    width: 540px;
                    .upload{
                        margin-top: 20px;
                        width: 100%;
                        .el-upload{
                            width: 100%;
                            height: 200px;
                        }
                        .el-upload-dragger{
                            height: 200px;
                            background-color: rgba(45, 138, 245, 0.06);
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .uploadbutton{
                                p{
                                    color: rgb(96, 98, 102);
                                    font-size: 14px;
                                    text-align: center;
                                    margin-top: 12px;
                                }
                            }
                        }
                        .tip{
                            font-size: 12px;
                            color: #999;
                            text-align: center;
                            margin-top: 12px;
                        }
                    }
                    .role{
                        margin-top: 24px;
                        .roletitle{
                            i{
                                color: #E6A23C;
                            }
                            span{
                                color:rgb(51, 51, 51);
                                font-size:12px;
                            }
                        }
                        .lists{
                            display: flex;
                            flex-wrap: wrap;
                            margin-top: 14px;
                            gap: 10px;
                            li{
                                flex: 0 0 23%;
                                position: relative;
                                div{
                                    width: 100%;
                                    height: 100px;
                                    overflow: hidden;
                                    border-radius: 9px;
                                    position: relative;
                                    video{
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        transform: translate(-50%,-50%);
                                        display: block;
                                        width: 100%;
                                        // height: 100%;
                                        cursor: pointer;
                                        position: relative;
                                        z-index: 10;
                                    }
                                }
                            }
                            .on::after,li:hover::after{
                                content:"";
                                display: block;
                                position: absolute;
                                background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
                                border-radius:9px;
                                width: 104%;
                                height: 104%;
                                top: -2%;
                                left: -2%;
                                z-index: 2;
                            }
                        }

                        .selectbox{
                            margin-top: 24px;
                            padding-top: 24px;
                            border-top: 1px solid rgb(244, 245, 247);
                            ul{
                                display: flex;
                                align-items: center;
                                margin-bottom: 24px;
                                li:nth-child(1){
                                    width: 80px;
                                    margin-right: 10px;
                                    font-size: 14px;
                                    color: #333;
                                    display: flex;
                                    align-items: center;
                                    i{
                                        color: rgb(228, 231, 237);
                                        font-size: 16px;
                                    }
                                }
                            }
                        }
                    }
                }
                > div:nth-child(2){
                    flex: 1 0 10%;
                    .tab{
                        margin-top: 20px;
                        padding: 4px;
                        background-color: #f4f5f7;
                        border-radius: 40px;
                        ul{
                            display: flex;
                            li{
                                flex:0 0 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #666;
                                cursor: pointer;
                                height: 44px;
                                z-index: 1;
                            }
                            .on{
                                color: #333;
                                background-color: #fff;
                                border-radius: 40px;
                            }
                        }
                    }
                    .tabbox1{
                        margin-top: 24px;
                        .button{
                            width: 200px;
                            margin: 40px auto 0;
                            background-image: linear-gradient(
                                106.92deg,
                                rgb(16, 197, 254) 14.83%,
                                rgb(16, 147, 254) 31.52%,
                                rgb(79, 79, 231) 65.11%,
                                rgb(182, 12, 185) 91.29%,
                                rgb(224, 202, 245) 102.83%
                            );
                            height: 42px;
                            padding: 0 20px;
                            border: 0;
                            border-radius: 6px;
                            color: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            font-size: 16px;
                        }
                        .el-textarea{
                            background: #f4f5f7;
                            border: 1px solid #f4f5f7;
                            border-radius: 8px;
                            padding: 10px ;
                            .el-textarea__inner{
                                position: relative;
                                --el-fill-color-blank: transparent;
                                height: 100%;
                                background-color: transparent;
                                border: none;
                            }
                        }
                        .type{
                            display: flex;
                            gap: 8px;
                            margin-top: 20px;
                            li{
                                text-align: center;
                                padding: 5px 12px;
                                border: 1px solid #f4f5f7;
                                border-radius: 6px;
                                background: #fff;
                                flex-shrink: 0;
                                cursor: pointer;
                                font-size: 14px;
                            }
                            .on{
                                background: #f4f5f7;
                            }
                        }
                        .el-scrollbar{
                            height: 300px;
                            .el-scrollbar__wrap{
                                overflow-x: hidden;
                            }
                        }
                        .usebox{
                            display: flex;
                            flex-wrap: wrap;
                            gap:12px;
                            margin-top: 24px;
                            li{
								justify-content: center;
                                width: 200px;
                                height: 48px;
                                border: 1px solid #f4f5f7;
                                background-color: #f4f5f7;
                                border-radius: 8px;
                                margin: 5px 0;
                                padding: 0 8px;
                                cursor: pointer;
                                position: relative;
                                display: flex;
                                align-items: center;
                                justify-content: space-betweenc;
                                font-size: 14px;
                                color: #333;
                                
                               text-align: center;
                            
                            }
                            .on{
                                border: 1px solid #2d8af5;
                                background-color: #2d8af5;
                                color: #fff;
                            }
                        }

                        .slider{
                            display: flex;
                            align-items: center;
                            width: 350px;
                            font-size: 14px;
                            border: 1px solid #e6e9ed;
                            border-radius: 8px;
                            padding: 16px 20px;
                            gap: 10px;
                            margin-bottom: 10px;
                            .el-slider{
                                flex: 1 0 10%;
                            }
                        }
                    }
                    .tabbox2{
                        margin-top: 20px;
                        width: 100%;
                        .el-upload{
                            width: 100%;
                            height: 200px;
                        }
                        .el-upload-dragger{
                            height: 200px;
                            background-color: rgba(45, 138, 245, 0.06);
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .uploadbutton{
                                p{
                                    color: rgb(96, 98, 102);
                                    font-size: 14px;
                                    text-align: center;
                                    margin-top: 12px;
                                }
                            }
                        }
                        .tip{
                            font-size: 12px;
                            color: #999;
                            text-align: center;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }
    }
	.tabbox2{
	    margin-top: 20px;
	    width: 100%;
	    .el-upload{
	        width: 100%;
	        height: 200px;
	    }
	    .el-upload-dragger{
	        height: 200px;
	        background-color: rgba(45, 138, 245, 0.06);
	        width: 100%;
	        display: flex;
	        align-items: center;
	        justify-content: center;
	        .uploadbutton{
	            p{
	                color: rgb(96, 98, 102);
	                font-size: 14px;
	                text-align: center;
	                margin-top: 12px;
	            }
	        }
	    }
	    .tip{
	        font-size: 12px;
	        color: #999;
	        text-align: center;
	        margin-top: 12px;
	    }
	}
</style>